/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TGetHouseStatsDesktopFicheringModel,
  IGetHouseStatsDesktopFicheringRequest,
  IMappers,
  IGetHouseStatsDesktopFicheringResponse,
  IGetHouseStatsDesktopFicheringResponseError,
  TGetHouseStatsDesktopFicheringResponse,
} from './types';

const defaultConfig: TGetHouseStatsDesktopFicheringModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'newbuilding-card',
  pathApi: '/v1/get-house-stats-desktop-fichering/',
  hostType: 'api',
} as TGetHouseStatsDesktopFicheringModel;

function createGetHouseStatsDesktopFicheringModel(
  parameters: IGetHouseStatsDesktopFicheringRequest,
): TGetHouseStatsDesktopFicheringModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetHouseStatsDesktopFicheringOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetHouseStatsDesktopFicheringRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetHouseStatsDesktopFichering<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetHouseStatsDesktopFicheringOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TGetHouseStatsDesktopFicheringResponse
> {
  const { response, statusCode } = await httpApi.fetch(createGetHouseStatsDesktopFicheringModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetHouseStatsDesktopFicheringResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetHouseStatsDesktopFicheringResponseError);
    }
  }

  return { response, statusCode } as TGetHouseStatsDesktopFicheringResponse;
}

export { defaultConfig, createGetHouseStatsDesktopFicheringModel, fetchGetHouseStatsDesktopFichering };
